<template>
  <div class="m-content">
    <div class="m-portlet">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <span class="m-portlet__head-icon m--hide">
              <i class="la la-gear"></i>
            </span>
            <h3 class="m-portlet__head-text">
              {{ formTitle }}
            </h3>
          </div>
        </div>
        <div class="m-portlet__head-tools">
          <!--                    <a-->
          <!--                            href="#"-->
          <!--                            :class="{'btn btn-primary m-btn m-btn&#45;&#45;icon m-btn&#45;&#45;wide m-btn&#45;&#45;sm m&#45;&#45;margin-right-10': true, 'disabled': !formValidation || !basicForm }"-->
          <!--                            @click.prevent="saveProduct"-->
          <!--                            v-show="basicForm">-->
          <!--                        <span>-->
          <!--                            <i class="la la-check" v-show="success"></i>-->
          <!--                            <span>{{ saveBtnText }}</span>-->
          <!--                        </span>-->
          <!--                    </a>-->

          <button
            v-if="canDuplicateProduct"
            @click="triggerDuplicateAction(product.product_id)"
            class="btn btn-success btn-sm"
            style="margin-right: 5px;"
            v-show="success || editingProduct"
          >
            <span><i class="la la-copy"></i></span>
            {{ labels.duplicate_product }}
          </button>
          <button
            v-if="canDeleteProduct"
            @click="triggerDeleteAction(product.product_id, product.name)"
            class="btn btn-info btn-sm"
            style="margin-right: 5px;"
            v-show="success || editingProduct"
          >
            <span><i class="la la-trash"></i></span> {{ labels.delete_product }}
          </button>
          <button
            @click="$router.go(-1)"
            class="btn btn-secondary m-btn m-btn--icon m-btn--wide m-btn--sm m--margin-right-10"
          >
            <span
              ><span>{{ returnLabel }}</span></span
            >
          </button>
        </div>
      </div>

      <!--begin::Form-->
      <form class="m-form">
        <div id="product_form" class="m-portlet__body">
          <div class="m-portlet__head-tools row">
            <ul
              class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--left m-tabs-line--success"
              role="tablist"
            >
              <li
                class="nav-item m-tabs__item"
                v-if="fullProductManagementAccess"
              >
                <a
                  :class="{
                    'nav-link m-tabs__link': true,
                    active: currentTab === 1
                  }"
                  data-toggle="tab"
                  href="#"
                  role="tab"
                  @click.prevent="switchExtendedTabs(1)"
                >
                  <i class="flaticon-share m--hide"></i>
                  {{ labels["product_information"] }}
                </a>
              </li>
              <li class="nav-item m-tabs__item">
                <a
                  :class="{
                    'nav-link m-tabs__link': true,
                    active: currentTab === 2
                  }"
                  data-toggle="tab"
                  href="#m_user_profile_tab_2"
                  role="tab"
                  @click.prevent="switchExtendedTabs(2)"
                >
                  {{ labels["product_specification"] }}
                </a>
              </li>
              <li class="nav-item m-tabs__item" v-if="!extendedForm">
                <a
                  :class="{
                    'nav-link m-tabs__link': true,
                    active: currentTab === 3,
                    disabled: !success && !editingProduct
                  }"
                  data-toggle="tab"
                  href="#m_user_profile_tab_3"
                  role="tab"
                  @click.prevent="switchExtendedTabs(3)"
                >
                  {{ labels["manage_stock_title"] }}
                </a>
              </li>
              <template v-else>
                <li
                  class="nav-item m-tabs__item"
                  v-if="fullProductManagementAccess"
                >
                  <a
                    :class="{
                      'nav-link m-tabs__link': true,
                      active: currentTab === 3,
                      disabled: !success && !editingProduct
                    }"
                    data-toggle="tab"
                    href="#m_user_profile_tab_3"
                    role="tab"
                    @click.prevent="switchExtendedTabs(3)"
                  >
                    {{ labels["product_claims"] }}
                  </a>
                </li>
                <li
                  class="nav-item m-tabs__item"
                  v-if="fullProductManagementAccess"
                >
                  <a
                    :class="{
                      'nav-link m-tabs__link': true,
                      active: currentTab === 4,
                      disabled: !success && !editingProduct
                    }"
                    data-toggle="tab"
                    href="#m_user_profile_tab_4"
                    role="tab"
                    @click.prevent="switchExtendedTabs(4)"
                  >
                    {{ labels["manage_ingredients"] }}
                  </a>
                </li>
                <li
                  class="nav-item m-tabs__item"
                  v-if="fullProductManagementAccess"
                >
                  <a
                    :class="{
                      'nav-link m-tabs__link': true,
                      active: currentTab === 5,
                      disabled: !success && !editingProduct
                    }"
                    data-toggle="tab"
                    href="#m_user_profile_tab_5"
                    role="tab"
                    @click.prevent="switchExtendedTabs(5)"
                  >
                    {{ labels["manage_patents"] }}
                  </a>
                </li>
                <li
                  class="nav-item m-tabs__item"
                  v-if="fullProductManagementAccess"
                >
                  <a
                    :class="{
                      'nav-link m-tabs__link': true,
                      active: currentTab === 6,
                      disabled: !success && !editingProduct
                    }"
                    data-toggle="tab"
                    href="#m_user_profile_tab_6"
                    role="tab"
                    @click.prevent="switchExtendedTabs(6)"
                  >
                    {{ labels["manage_stock_title"] }}
                  </a>
                </li>
              </template>
            </ul>
          </div>

          <!-- PRODUCT MANAGEMENT TABS -->
          <component
            :is="tab1Component"
            v-show="currentTab === 1"
            :product="product"
            :disabledClass="disabledClass"
            v-model="images"
            :images="images"
            :formValidation="formValidation"
          ></component>
          <component
            :is="tab2Component"
            v-show="currentTab === 2"
            :product="product"
            :disabledClass="disabledClass"
            :images="images"
            :formValidation="formValidation"
          ></component>
          <component
            :is="tab3Component"
            :productId="product.product_id"
            :index="index"
            :product="product"
            v-show="currentTab === 3"
          ></component>
          <component
            :is="tab4Component"
            :productId="product.product_id"
            :index="index"
            v-if="currentTab === 4"
          ></component>
          <component
            :is="tab5Component"
            :productId="product.product_id"
            :index="index"
            v-if="currentTab === 5"
          ></component>
          <component
            :is="tab6Component"
            :productId="product.product_id"
            :index="index"
            :product="product"
            v-if="currentTab === 6"
          ></component>
        </div>
      </form>
      <!--end::Form-->
    </div>

    <a
      id="modalLink"
      href="#"
      data-toggle="modal"
      data-target="#m_modal_form_entry_patent"
    ></a>

    <div
      class="modal fade"
      id="m_modal_form_entry_patent"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div
        style="max-width: 800px;"
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <form-modal v-if="formData"></form-modal>
      </div>
    </div>
    <product-form-modal
      :formValidation="formValidation"
      :requiredFields="requiredFields"
    ></product-form-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Choices from 'choices.js';
import { HTTP } from '../../assets/js/axiosConfig';
// import Swal from 'sweetalert2'
// Mixins
import Uuid from '../../assets/js/mixins';
import InitDatePicker from '../../assets/js/mixins';
import SetDefaultDate from '../../assets/js/mixins';
import GetCRUDName from '../../assets/js/mixins';
import SendPostRequest from '../../assets/js/mixins';
import duplicateAction from '../../assets/js/duplicateMixin';
import deleteProductAction from '../../assets/js/deleteProductMixin';
// Components
import FormModal from '../Modals/FormModal';
import ProductFormModal from '../Modals/ProductFormModal';

// Choices list
const resourceChoices = {};

export default {
  name: 'ProductForm',
  mixins: [
    Uuid,
    InitDatePicker,
    SetDefaultDate,
    GetCRUDName,
    SendPostRequest,
    duplicateAction,
    deleteProductAction,
  ],
  components: {
    FormModal,
    ProductFormModal,
  },
  data() {
    return {
      product: {
        product_id: '', // uuid generated in app
        brand_id: '', // select one - brandId
        name: '', // free text
        collection_id: '', // select one - collectionId
        category_id: '', // select one - category Id
        areas: [], // multi choice - area ids
        type_id: '', // select one - status id
        type_packs: [], // multi select - type-pack id
        package_capacities: [], // free text (num)
        type_skins: [], // multi choice - type-skin ids
        targets: [], // multi select - target ids
        ingredients: [], // multi select - ingredient ids
        tinted: false, // boolean
        made_in_france: false, // boolean
        texture_id: '', // select one - texture id
        texturotheque_id: '',
        spf: '', // spf value
        specific_mention: '', // free text
        link_website: '', // string (url)
        country_distribution: 'FR', // select one? - country code
        commercialized: true,
        archived: false,
        date_archived: null,
        uva: '', // uva string value,
        perfume_claimed: false,
        perfume: false,
        innovation: false,
        comment_cip: '',
        list_inci: '',
        distribution_channels: [],
        price: '',
        price_liter: '',
        revindication: '',
        bio: false,
        manual: '',
        date_commercialized: null,
        comment_rd: '',
      },
      activeIngredients: false,
      currentTab: 1,
      images: [],
      myDropzone: null,
      imageChoices: null,
      requiredFields: [
        'product_id',
        'brand_id',
        'name',
        'collection_id',
        'category_id',
        'areas',
        'type_id',
        'type_packs',
        'package_capacities',
        'type_skins',
        'targets',
      ],
      cancel: null,
      index: 'new',
      stockId: null,
      timeout: null,
      extendedForm: null,
      tab1Component: '',
      tab2Component: '',
      tab3Component: '',
      tab4Component: '',
      tab5Component: '',
      tab6Component: '',
    };
  },
  watch: {
    product: {
      handler(value) {},
      deep: true,
    },
    'product.archived': function (value) {
      !value ? (this.product.date_archived = null) : null;
    },
    cruds: {
      handler() {
        this.resetChoices(this.updatedResource);
      },
      deep: true,
    },
    deletedResource() {
      this.deletedResource
        ? this.updateFormOnDelete(this.deletedResource.name)
        : null;
    },
  },
  computed: {
    ...mapState({
      cruds: (store) => store.crudData.cruds,
      updatedResource: (store) => store.crudData.updatedResource,
      deletedResource: (store) => store.crudData.deletedResource,
      labels: (store) => store.labels,
      formData: (state) => state.products.formData,
      sessionUser: (state) => state.sessionUser,
      success: (state) => state.products.success,
      editingProduct: (state) => state.products.editingProduct,
      newCRUD: (store) => store.crudData.newCRUD,
    }),
    ...mapGetters([
      'getIdByName',
      'fullProductManagementAccess',
      'canDuplicateProduct',
      'canDeleteProduct',
      'canEditProduct',
    ]),
    formTitle() {
      return this.product.name
        ? this.product.name.toUpperCase()
        : this.labels.create_a_product;
    },
    saveBtnText() {
      if (this.success) {
        return this.labels.saved;
      }

      return this.labels.save;
    },
    imageChoiceList() {
      const choices = [];
      this.images.forEach((image) => {
        const choice = {
          label: image.filename,
          value: image.photo_id,
          selected: false,
        };
        choices.push(choice);
      });

      return choices;
    },
    defaultImage() {
      // Check which image has default = true
      const results = this.images.filter((image) => image.is_main);

      // return the gcs url to render the image
      if (results.length) {
        return results[0].link;
      }
      return null;
    },
    formValidation() {
      // Required fields = product_id, brand_id, name, collection_name, category_id, areas, type_id, type_packs, targets
      // Loop over each required field to check if there is a value entered
      return this.requiredFields.filter((field) => {
        if (!this.product[field] || !this.product[field].length) {
          return field;
        }
      });
    },
    returnRouteName() {
      return this.extendedForm ? 'ProductList' : 'StockList';
    },
    loadTab1Component() {
      if (this.fullProductManagementAccess) {
        return () => import('./ProductBasicInfo');
      }
      if (this.sessionUser && this.sessionUser.roles[0] === 'ROLE_RESEARCH') {
        return () => import('./ProductSpecRD');
      }
    },
    loadTab2Component() {
      if (this.fullProductManagementAccess) {
        return () => import('./ProductSpecification.vue');
      }
    },
    loadTab3Component() {
      if (!this.extendedForm) {
        return () => import('../Stocks/ProductStocks');
      }
      if (this.fullProductManagementAccess) {
        return () => import('./Claims');
      }
    },
    loadTab4Component() {
      if (!this.extendedForm) {
        return null;
      }
      if (this.fullProductManagementAccess) {
        return () => import('./ActiveIngredients');
      }
    },
    loadTab5Component() {
      if (!this.extendedForm) {
        return null;
      }
      if (this.fullProductManagementAccess) {
        return () => import('./ManagePatents');
      }
    },
    loadTab6Component() {
      if (!this.extendedForm) {
        return null;
      }
      if (this.fullProductManagementAccess) {
        return () => import('../Stocks/ProductStocks');
      }
    },
    basicForm() {
      return this.currentTab === 1 || this.currentTab === 2;
    },
    returnLabel() {
      return this.labels.return;
      if (this.returnRouteName === 'ProductList') {
        return this.labels.back_to_product_list;
      }
      return this.labels.back_to_stocks;
    },
    disabledClass() {
      return !this.fullProductManagementAccess ? 'disabled' : '';
    },
  },
  methods: {
    ...mapActions([
      'products/setActiveIndex',
      'products/updateProductList',
      'products/setEditingProductStatus',
      'products/setSuccessStatus',
      'setUserInfo',
    ]),
    initChoices() {
      const my = this;
      $('.m-choices').each(function () {
        const element = this;
        const elementId = $(this).attr('id');
        const choicesSingle = new Choices(element, {
          renderChoiceLimit: 100,
          searchResultLimit: 10,
          searchFields: ['label'],
          shouldSort: false,
        });

        resourceChoices[elementId] = choicesSingle;
      });

      $('.m-choices-multiple').each(function () {
        const element = this;
        const elementId = $(this).attr('id');
        const choicesMulti = new Choices(element, {
          removeItems: true,
          removeItemButton: true,
          renderChoiceLimit: 100,
          searchResultLimit: 10,
          searchFields: ['label'],
          shouldSort: false,
        });

        resourceChoices[elementId] = choicesMulti;
      });
    },
    resetChoices(elementId) {
      const choices = [];
      const resourceId = this.getCRUDName(elementId);
      const my = this;

      // check if not a required field AND not a multi-choice
      if (
        this.requiredFields.indexOf(resourceId) === -1
        && resourceChoices[elementId]
          && !resourceChoices[elementId]._isSelectMultipleElement
      ) {
        choices.push({ value: '', label: this.labels.none });
      }
      let indexCrud;
      if (this.newCRUD) {
        switch (this.newCRUD.originator) {
          case 'brands':
            indexCrud = 'brand_id';
            my.product.brand_id = this.newCRUD.item[indexCrud];
            break;
          case 'categories':
            indexCrud = 'category_id';
            my.product.category_id = this.newCRUD.item[indexCrud];
            break;
          case 'collections':
            indexCrud = 'collection_id';
            my.product.collection_id = this.newCRUD.item[indexCrud];
            break;
          case 'areas':
            indexCrud = 'area_id';
            my.product.areas.push(this.newCRUD.item[indexCrud]);
            break;
          case 'type_skins':
            indexCrud = 'type_skin_id';
            my.product.type_skins.push(this.newCRUD.item[indexCrud]);
            break;
          case 'targets':
            indexCrud = 'target_id';
            my.product.targets.push(this.newCRUD.item[indexCrud]);
            break;
          case 'textures':
            indexCrud = 'texture_id';
            my.product.texture_id = this.newCRUD.item[indexCrud];
            break;
          case 'texturotheques':
            indexCrud = 'texturotheque_id';
            my.product.texturotheque_id = this.newCRUD.item[indexCrud];
            break;
          case 'types':
            indexCrud = 'type_id';
            my.product.type_id = this.newCRUD.item[indexCrud];
            break;
          case 'type_packs':
            indexCrud = 'type_pack_id';
            my.product.type_packs.push(this.newCRUD.item[indexCrud]);
            break;
          case 'package_capacities':
            indexCrud = 'package_capacity_id';
            my.product.package_capacities.push(this.newCRUD.item[indexCrud]);
            break;
          case 'distribution_channels':
            indexCrud = 'distribution_channel_id';
            my.product.distribution_channels.push(this.newCRUD.item[indexCrud]);
            break;
          default:
          // code block
        }
      }

      this.cruds[elementId].map((resource) => {
        const choice = {
          value: resource[resourceId],
          label: resource.name,
        };

        if (
          indexCrud
          && this.newCRUD
          && this.newCRUD.item[indexCrud] === resource[resourceId]
        ) {
          choice.selected = true;
          this.$store.dispatch('setNewCRUD', null);
        }
        choices.push(choice);
      });

      if (
        resourceChoices[elementId]
        && this.deletedResource
        && this.deletedResource.itemId
      ) {
        resourceChoices[elementId].removeActiveItemsByValue(
          my.deletedResource.itemId,
        );
      }
      resourceChoices[elementId]
        ? resourceChoices[elementId].setChoices(choices, 'value', 'label', true)
        : null;
    },
    findResourceByName(resource, search) {
      const results = this.cruds[resource].filter((data) => {
        const dataName = data.name.toLowerCase();
        const searchText = search.toLowerCase();
        if (dataName === searchText) {
          return data;
        }
      });
      if (!results.length) {
        if (resource === 'segmentations') {
        } else {
          this.createNewEntry(resource, search);
        }
      }
    },
    createNewEntry(resource, name) {
      // Get resource_id
      const resourceId = this.getCRUDName(resource);
      // Create new resource object
      const item = {
        [resourceId]: this.uuid(),
        name,
      };
      this.sendPostRequest(resource, item);
    },
    getProductInfo(id) {
      // Get product object
      HTTP.get(`api/products/${id}`)
        .then((response) => {
          this.product = response.data;
          this.initDatePicker(this.product, 'productForm');
          this.startTimeout(1000);
        })
        .catch((err) => console.log('err', err));
      // Get product images
      HTTP.get(`api/products/${id}/photos`)
        .then((response) => {
          this.images = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    startTimeout(delay) {
      const my = this;
      this.timeout = setTimeout(() => {
        my.initChoices();
      }, delay);
    },
    async dynamicImports() {
      const arrayPromises = [];
      // Dynamically import the tab 3 component => either stock manage / ingredients
      if (this.fullProductManagementAccess) {
        arrayPromises.push(
          this.loadTab1Component()
            .then(() => {
              this.tab1Component = () => this.loadTab1Component();
            })
            .catch(() => {
              this.tab1Component = '';
            }),
        );

        arrayPromises.push(
          this.loadTab2Component()
            .then(() => {
              this.tab2Component = () => this.loadTab2Component();
            })
            .catch(() => {
              this.tab2Component = '';
            }),
        );

        arrayPromises.push(
          this.loadTab3Component()
            .then(() => {
              this.tab3Component = () => this.loadTab3Component();
            })
            .catch(() => {
              this.tab3Component = '';
            }),
        );

        if (this.extendedForm) {
          // Dynamically import the tab 4 component => patents
          arrayPromises.push(
            this.loadTab4Component()
              .then(() => {
                this.tab4Component = () => this.loadTab4Component();
              })
              .catch(() => {
                this.tab4Component = '';
              }),
          );

          arrayPromises.push(
            this.loadTab5Component()
              .then(() => {
                this.tab5Component = () => this.loadTab5Component();
              })
              .catch((err) => {
                this.tab5Component = '';
              }),
          );

          arrayPromises.push(
            this.loadTab6Component()
              .then(() => {
                this.tab6Component = () => this.loadTab6Component();
              })
              .catch((err) => {
                this.tab6Component = '';
              }),
          );
        }
      } else {
        arrayPromises.push(
          this.loadTab1Component()
            .then(() => {
              this.tab1Component = () => this.loadTab1Component();
            })
            .catch(() => {
              this.tab1Component = '';
            }),
        );
      }

      await Promise.all(arrayPromises);
    },
    switchExtendedTabs(tab) {
      this.currentTab = tab;
      this['products/setActiveIndex'](null);
    },
    removeDeletedArrayValue(key, itemId) {
      const index = this.product[key].indexOf(itemId);
      return index !== -1 ? this.product[key].splice(index, 1) : null;
    },
    removeDeletedStringValue(key, itemId) {
      return this.product[key] === itemId
        ? this.$set(this.product, key, '')
        : null;
    },
    updateFormOnDelete(resource) {
      switch (resource) {
        case 'areas':
          // areas
          this.removeDeletedArrayValue('areas', this.deletedResource.itemId);
          break;
        case 'brands':
          // brand_id
          this.removeDeletedStringValue(
            'brand_id',
            this.deletedResource.itemId,
          );
          break;
        case 'categories':
          // category_id
          this.removeDeletedStringValue(
            'category_id',
            this.deletedResource.itemId,
          );
          break;
        case 'collections':
          // collection_id
          this.removeDeletedStringValue(
            'collection_id',
            this.deletedResource.itemId,
          );
          break;
        case 'distribution_channels':
          // distribution_channels
          this.removeDeletedArrayValue(
            'distribution_channels',
            this.deletedResource.itemId,
          );
          break;
        case 'package_capacities':
          // package_capacities
          this.removeDeletedArrayValue(
            'package_capacities',
            this.deletedResource.itemId,
          );
          break;
        case 'segmentations':
          // dedicated endpoint
          break;
        case 'targets':
          // targets
          this.removeDeletedArrayValue('targets', this.deletedResource.itemId);
          break;
        case 'textures':
          // texture_id
          this.removeDeletedStringValue(
            'texture_id',
            this.deletedResource.itemId,
          );
          break;
        case 'texturotheques':
          // texturotheque_id
          this.removeDeletedStringValue(
            'texturotheque_id',
            this.deletedResource.itemId,
          );
          break;
        case 'types':
          // type_id
          this.removeDeletedStringValue('type_id', this.deletedResource.itemId);
          break;
        case 'type_packs':
          // type_packs
          this.removeDeletedArrayValue(
            'type_packs',
            this.deletedResource.itemId,
          );
          break;
        case 'type_skins':
          // type_skins
          this.removeDeletedArrayValue(
            'type_skins',
            this.deletedResource.itemId,
          );
          break;
        default:
          break;
      }
    },
  },
  async mounted() {
    await this.dynamicImports();

    if (!this.$route.query.productId) {
      const my = this;
      setTimeout(() => {
        my.initChoices();
        my.initDatePicker(my.product, 'productForm');
      }, 500);
    }
  },
  created() {
    // Check if route name & user role to show/hide extended product form
    this.extendedForm = this.$route.name === 'ProductFormExt';
    // Check if productId param exists === editmode
    if (this.$route.query.productId) {
      const { productId } = this.$route.query;
      // Make request to get product details
      this.getProductInfo(productId);
      this['products/setEditingProductStatus'](true);
    } else {
      // Assign a product_id to product
      this.product.product_id = this.uuid();
      // Make "Adulte" default target
      const adultTarget = this.getIdByName('adulte', 'target_id', 'targets');
      adultTarget ? this.product.targets.push(adultTarget) : null;
    }

    this.$route.query.tab
      ? (this.currentTab = parseInt(this.$route.query.tab))
      : null;

    // ROLE_RESEARCH can only edit "Comments R&D"
    if (
      !this.fullProductManagementAccess
      && this.sessionUser && this.sessionUser.roles[0] === 'ROLE_RESEARCH'
    ) {
      this.currentTab = 1;
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
};
</script>

<style>
.m-portlet__head {
  border-bottom: 1px solid #ebedf200;
}

.new-product {
  text-align: center;
}

.image-preview {
  border: 2px dashed #34bfa3;
  border-radius: 4px;
  padding: 20px;
  text-align: center;
  min-height: 150px;
  background: white;
}

.image-preview > img {
  max-width: -webkit-fill-available;
  width: inherit;
}

textarea {
  resize: both;
  border-radius: 10px;
  border-color: #ebedf2;
}

.imageColumn {
  margin: 10px;
}

.imageGrid {
  max-width: 100%;
  height: auto;
}

.defaultImage {
  border: 5px solid #ffcc01;
}

.disabled {
  pointer-events: none;
  color: #afb2c1 !important;
}
.btn-primary.disabled {
  background-color: #6c757d1c !important;
  border: none;
  pointer-events: none;
  color: darkgrey !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Products/ProductForm.vue